import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'quote-layout-page',
  templateUrl: './quote-layout-page.component.html',
  styleUrls: ['./quote-layout-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteLayoutPageComponent {}
